import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-sanfex',
  template: `
    <p>
      sanfex works!
    </p>
  `,
  styles: []
})
export class SanfexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
